import { render } from "./TopRecommendation.component.vue?vue&type=template&id=b878c096"
import script from "./TopRecommendation.component.vue?vue&type=script&lang=js"
export * from "./TopRecommendation.component.vue?vue&type=script&lang=js"

import "./TopRecommendation.component.vue?vue&type=style&index=0&id=b878c096&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__